import { LinkButton, Icon, Typography } from "@bca/ui-library";
import React from "react";
import analytics from "../common/analytics/analytics"; 
import { IEventPushable } from "../common/analytics/analytics.types";

const pushStockAlertAnalytics = () => {
  analytics.push<IEventPushable>({
    event: {
      name: "click",
      category: "link",
      label: "create-stock-alert",
      action: "start",
      section: "search-ellipsis",
    },
  });
};

const CreateStockAlertButton: React.FunctionComponent<{
  createStockAlertLink: string;
}> = ({ createStockAlertLink }) => {
  return (
    <LinkButton
      data-testid="ellipsis-create-stock-alert"
      variant="tertiary"
      height="30px"
      px={0}
      target="_blank"
      href={createStockAlertLink}
      onClick={() => {
        pushStockAlertAnalytics();
      }}
    >
      <Icon
        width="16px"
        name="bell"
        weight="regular"
        color="primary-light-blue"
        mb="2px"
        mr={2}
      ></Icon>
      <Typography
        color="primary-light-blue"
        variant="body"
        my="0"
        css={`
          text-decoration: underline;
        `}
      >
        Create Stock Alert
      </Typography>
    </LinkButton>
  );
};

export default CreateStockAlertButton;
